// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"157d757f","988":"7fb07061"}[chunkId] + ".chunk.css";
};